import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Divider } from 'antd';
import TemplateMemory from './TemplateMemory';
import GlobalPreferences from './GlobalPreferences';
import TeamPreferences from './TeamPreferences';
import { MemoryFeatureFlag } from './FeatureFlag';
import { SegmentedTabs } from '../PastEncounter/SegmentedTabs';

const Memory = () => {
  const [activeTab, setActiveTab] = useState('User');

  const { currentPractitioner } = useSelector((state) => ({
    ...state?.practitionerState,
  }));
  const isAdmin = currentPractitioner?.roles?.some((role) =>
    ['admin', 'superadmin'].includes(role)
  );

  const tabOptions = [
    { label: 'User', value: 'User' },
    ...(isAdmin ? [{ label: 'Team', value: 'Team' }] : []),
  ];

  return (
    <div className="settings-component page-wrapper">
      <div className="settings-component flex flex-col p-5 shadow-xl w-full md:w-[75%] bg-white rounded-xl">
        <div className="flex justify-start">
          <SegmentedTabs
            options={tabOptions}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            disabled={false}
          />
        </div>

        <div className={activeTab === 'User' ? 'mt-4 block' : 'mt-4 hidden'}>
          <div className="w-full flex justify-end">
            <MemoryFeatureFlag />
          </div>
          <div className="w-full">
            <GlobalPreferences />
          </div>
          <Divider />
          <div className="w-full">
            <TemplateMemory />
          </div>
        </div>

        {isAdmin && (
          <div className={activeTab === 'Team' ? 'mt-4 block' : 'mt-4 hidden'}>
            <div className="w-full flex justify-end">
              <MemoryFeatureFlag />
            </div>
            <div className="w-full">
              <TeamPreferences />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Memory;
